<div class="table-wrapper">
  <table class="custom-table">
    <thead>
      <tr>
        <th [style]="{ maxWidth: '40px' }"></th>
        <th *ngFor="let col of columns">
          <ng-container
            *ngIf="col.key === 'select' && withCheckboxes; else normalHeader"
          >
            <input
              type="checkbox"
              class="checkbox"
              [checked]="allSelected()"
              (change)="toggleAll($event.target.checked)"
            />
          </ng-container>

          <ng-template #normalHeader>
            {{ col.header }}
          </ng-template>
        </th>

        @if (withButton) {
          <th>Acción</th>
        }
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let row of data; let i = index">
        <!-- fila principal -->
        <tr class="main-row">
          <td class="expand" (click)="toggle(i)">
            @if (isExpanded(i)) {
              <img
                class="select-icon"
                src="/icons/chevron-up.svg"
                alt="Arrow Up Icon"
              />
            } @else {
              <img
                class="select-icon"
                src="/icons/chevron-down.svg"
                alt="Arrow Down Icon"
              />
            }
          </td>

          <td
            *ngFor="let col of columns"
            [class.center]="col.align === 'center'"
            [class.right]="col.align === 'right'"
          >
            <ng-container
              *ngIf="col.key === 'select' && col.cell && withCheckboxes"
              [ngSwitch]="col.cell(row)?.type"
            >
              <input
                class="checkbox"
                *ngSwitchCase="'checkbox'"
                type="checkbox"
                [checked]="isSelected(row)"
                (change)="toggleRow(row, $event.target.checked)"
              />
            </ng-container>

            <ng-container
              *ngIf="col.cell && col.key !== 'select'; else defaultCell"
            >
              {{ col.cell(row) }}
            </ng-container>

            <ng-template #defaultCell>
              {{ row[col.key] }}
            </ng-template>
          </td>
          @if (withButton) {
            <td>
              <app-button
                (click)="onButtonClick(row)"
                [label]="buttonLabel"
                variant="secondary"
              >
              </app-button>
            </td>
          }
        </tr>

        <!-- fila expandida -->
        <tr *ngIf="isExpanded(i)">
          <td colspan="100%">
            <ng-container
              *ngTemplateOutlet="
                expandedTemplate;
                context: {
                  $implicit: row,
                  close: toggle.bind(this, i),
                }
              "
            ></ng-container>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
